var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttention({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.733 11.2187L9.62072 2.88887C9.28189 2.32973 8.67781 2 8.00005 2C7.32228 2 6.71832 2.32973 6.37938 2.88887L1.26708 11.2187C0.913462 11.7921 0.913462 12.4804 1.25238 13.0681C1.59121 13.656 2.20997 14 2.88773 14H13.1123C13.8048 14 14.4089 13.6559 14.7477 13.0681C15.0865 12.4804 15.0865 11.7921 14.733 11.2187H14.733ZM8.0001 12.0503C7.55809 12.0503 7.20458 11.7061 7.20458 11.2761C7.20458 10.846 7.5582 10.502 8.0001 10.502C8.44211 10.502 8.79562 10.8461 8.79562 11.2761C8.79562 11.7061 8.44209 12.0503 8.0001 12.0503ZM8.85461 6.15772L8.57466 9.35489C8.54516 9.65602 8.26521 9.88534 7.95588 9.85674C7.67593 9.82804 7.45499 9.61302 7.44017 9.35489L7.16022 6.15772C7.11603 5.69889 7.46967 5.29745 7.94107 5.25446C8.41257 5.21146 8.82509 5.55559 8.86926 6.01433C8.85457 6.05733 8.85457 6.11474 8.85457 6.15774L8.85461 6.15772Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttention);
export default __webpack_public_path__ + "static/media/iconAttention.7dd7f5733e1e229b2f19a5839e6a5675.svg";
export { ForwardRef as ReactComponent };